/**
 * Wishlist Directive.
 *
 * Initialize wishlist object in angular based applications after we load dynamic content.
 *
 * Should be included on the container of the appropriate elements ( hues, products ) example:
 *
 * For further information see:
 *
 *  Core/List/List.js
 *
 */

HuesMdl.directive('wishlist',[ '$timeout', function( $timeout ) {

	return {
		restrict: 'A',
		link: function (scope) {
			if ( scope.$last === true ) {
				$timeout( function () {

					Samples.render();
					hueWishlist.render();
				});
			}
		}
	}

}]);